import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography, } from '@mui/material';
import { GRID_CHECKBOX_SELECTION_COL_DEF, DataGridPro, LicenseInfo } from '@mui/x-data-grid-pro';
import UploadIllusionEDLPullModSummary from './UploadIllusionEDLPullModSummary';
import IllusionCutSlider from '../../slider/IllusionCutSlider';
import PullModificationTimecodeTextField from '../../textfield/PullModificationTimecodeTextField';
import PullModificationPlateTextField from '../../textfield/PullModificationPlateTextField';
import PullModificationNumericTextField from '../../textfield/PullModificationNumericTextField';
LicenseInfo.setLicenseKey('17ca2e8476fa658618680f9f135dbc81T1JERVI6MzU2MTYsRVhQSVJZPTE4NzMzODQyMDIwMDAsS0VZVkVSU0lPTj0x',);


const UploadIllusionModifyDatagrid = (props) => {
    const { edlSummary, editedPlates, getDuplicatePlates, pullType, rows, selectionModel, setRows, setSelectionModel } = props;

    const clipnameColumn = [
        { 
            field: 'clipname',
            headerName: 'Clipname',
            width: 230,
        },
    ]

    const vfxColumn = [
        { 
            field: 'plate', 
            headerName: 'Plate Name', 
            width: 230, 
            renderCell: (params) => 
                <PullModificationPlateTextField
                    disabled={(edlSummary?.missing_plates ?? []).some(plate => plate.id === params.id)}
                    duplicatePlateIds={getDuplicatePlates(editedPlates?? [])?.map(plate => plate.id) ?? []}
                    setSelectionModel={setSelectionModel}
                    setPlateName={(value) => handleEditCellChange({ id: params.id, field: 'plate', value })}
                    plateName={editedPlates?.find(plate => plate.id === params.id)?.plate ?? ''}
                />
        }
    ]

    const dramaColumn = [
        { 
            field: 'sequence', 
            headerName: 'Plate Name', 
            width: 230, 
            renderCell: (params) => 
                <PullModificationPlateTextField
                    disabled={(edlSummary?.missing_plates ?? []).some(plate => plate.id === params.id)}
                    duplicatePlateIds={getDuplicatePlates(editedPlates?? [])?.map(plate => plate.id) ?? []}
                    setSelectionModel={setSelectionModel}
                    setPlateName={(value) => handleEditCellChange({ id: params.id, field: 'sequence', value })}
                    plateName={editedPlates?.find(plate => plate.id === params.id)?.sequence ?? ''}
                />
        }
    ]

    const cutColumns = [
        { 
            field: 'cut', 
            headerName: 'Cut', 
            width: 250,
            renderCell: (params) => 
                <IllusionCutSlider
                    framesToTimeCode={framesToTimeCode}
                    handleEditCellChange={handleEditCellChange}
                    params={params}
                    plateSummary={editedPlates?.find(plate => plate.id === params.id)}
                    disabled={(edlSummary?.missing_plates ?? []).some(plate => plate.id === params.id)}
                />
        },
        { 
            field: 'starttc', 
            headerName: 'Start TC', 
            width: 105,
            renderCell: (params) => 
                <PullModificationTimecodeTextField
                    fps={params.row?.framerate ?? 24}
                    framesToTimeCode={framesToTimeCode}
                    setValue={(value) => handleEditCellChange({ id: params.id, field: 'cut', value: [value, params.row?.cut?.at(1)] })}
                    source={params.row?.source ?? [0, 0]}
                    timeCodeToFrames={timeCodeToFrames}
                    value={editedPlates?.find(plate => plate.id === params.id)?.cut?.at(0) ?? 0}
                    disabled={(edlSummary?.missing_plates ?? []).some(plate => plate.id === params.id)}
                />
        },
        { 
            field: 'endtc', 
            headerName: 'End TC', 
            width: 105,
            renderCell: (params) =>
                <PullModificationTimecodeTextField
                    fps={params.row?.framerate ?? 24}
                    framesToTimeCode={framesToTimeCode}
                    setValue={(value) => handleEditCellChange({ id: params.id, field: 'cut', value: [params.row?.cut?.at(0), value] })}
                    source={params.row?.source ?? [0, 0]}
                    timeCodeToFrames={timeCodeToFrames}
                    value={editedPlates?.find(plate => plate.id === params.id)?.cut?.at(1) ?? 0}
                    disabled={(edlSummary?.missing_plates ?? []).some(plate => plate.id === params.id)}
                />
        }
    ];

    const bufferColumns = [
        // { 
        //     field: 'handle', 
        //     headerName: 'Handles', 
        //     width: 70, 
        //     renderCell: (params) => 
        //         <PullModificationNumericTextField
        //             disabled={(edlSummary?.missing_plates ?? []).some(plate => plate.id === params.id)}
        //             setPlateNumericValue={(value) => handleEditCellChange({ id: params.id, field: 'handle', value })}
        //             plateNumericValue={editedPlates?.find(plate => plate.id === params.id)?.handle ?? 0}
        //         />
        // },
        { 
            field: 'customframestart', 
            headerName: 'Frame Start', 
            width: 95, 
            renderCell: (params) =>
                <PullModificationNumericTextField
                    disabled={(edlSummary?.missing_plates ?? []).some(plate => plate.id === params.id)}
                    plateNumericValue={editedPlates?.find(plate => plate.id === params.id)?.customframestart ?? 1001}
                    setPlateNumericValue={(value) => handleEditCellChange({ id: params.id, field: 'customframestart', value })}
                />
        }
    ];

    const [duplicatePlateIds, setDuplicatePlateIds] = useState([]);

    const framesToTimeCode = (frames, fps = 24) => {
        frames = Number(frames);
        fps = Number(fps);
        if (isNaN(frames) || isNaN(fps) || fps <= 0) {
            return '00:00:00:00';
        }
        const hours = Math.floor(frames / (fps * 3600));
        const minutes = Math.floor((frames % (fps * 3600)) / (fps * 60));
        const seconds = Math.floor((frames % (fps * 60 * 60)) / fps % 60);
        const frame = Math.floor(frames % fps);
        const pad = (num) => String(num).padStart(2, '0');
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}:${pad(frame)}`;
    };

    const timeCodeToFrames = (timecode, fps = 24) => {
        const [hours, minutes, seconds, frames] = timecode.split(':').map(Number);
        fps = Number(fps);
        if (isNaN(hours) || isNaN(minutes) || isNaN(seconds) || isNaN(frames) || isNaN(fps) || fps <= 0) {
            return 0;
        }
        return (hours * 3600 + minutes * 60 + seconds) * fps + frames;
    }

    // Updates the values of fields in Datagrid for the frontend and state
    const handleEditCellChange = ({ id, field, value }) => {
        setRows((prevRows) => prevRows.map((row) =>
            row.id === id ? { ...row, [field]: value } : row
        ));
    };

    useEffect(() => {
        setDuplicatePlateIds(getDuplicatePlates(editedPlates?? [])?.map(plate => plate.id) ?? []);
        //Remove duplicate plates from selection
    }, [editedPlates]);


    return (
            <DataGridPro
                sx={{
                    backgroundColor: '#101010',
                    borderColor: '#122218',
                    '& .MuiDataGrid-root': { cursor: 'pointer' },
                    '& .MuiDataGrid-cell:hover': { color: 'rgb(76, 146, 107)' },
                    '& .MuiDataGrid-columnSeparator': {
                        borderColor: 'green',
                        borderWidth: '2px',
                        visibility: 'visible',
                        '&:hover': { borderColor: 'rgb(76, 146, 107)' },
                    },
                    '& .MuiDataGrid-columnHeaders': { backgroundColor: '#101010' },
                    '& .MuiDataGrid-columnHeader': {
                        fontSize: 14,
                        color: 'white',
                        fontWeight: 'bold',
                        borderBottom: 'None',
                    },
                    '& .MuiDataGrid-row': { border: 'none' },
                    '& .MuiDataGrid-rowCount, & .MuiDataGrid-selectedRowCount': { color: 'white' },
                    '& .MuiDataGrid-cell': {
                        border: 'none',
                        color: 'white',
                        fontSize: 13,
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#161618' },
                    '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#202020' },
                    '& .MuiDataGrid-row:hover': { backgroundColor: 'rgba(76, 146, 107, 0.1)' },
                    '& .MuiDataGrid-pinnedColumnHeaders, & .MuiDataGrid-pinnedColumns': { backgroundColor: '#101010' },
                    '& .MuiDataGrid-pinnedColumns .MuiDataGrid-cell': {
                        backgroundColor: 'inherit',
                        color: 'white',
                        fontSize: 13,
                        border: 'none',
                    },
                    '& .MuiDataGrid-pinnedColumns .MuiDataGrid-row:nth-of-type(odd) .MuiDataGrid-cell': { backgroundColor: '#161618' },
                    '& .MuiDataGrid-pinnedColumns .MuiDataGrid-row:nth-of-type(even) .MuiDataGrid-cell': { backgroundColor: '#202020' },
                    '& .MuiDataGrid-pinnedColumns .MuiDataGrid-row:hover .MuiDataGrid-cell': { backgroundColor: 'rgba(76, 146, 107, 0.1)' },
                    '& .MuiDataGrid-cell--withRenderer .MuiCheckbox-root': {
                        color: 'white',
                        transform: 'scale(0.7)',
                        '& .MuiSvgIcon-root': { borderRadius: '50%' },
                        '&.Mui-checked': { color: '#54a277' },
                    },
                    '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
                        color: 'white',
                        transform: 'scale(0.8)',
                        '& .MuiSvgIcon-root': { borderRadius: '50%' },
                        '&.Mui-checked': { color: '#54a277' },
                    },
                    // Remove all row styles if disabled-row
                    '& .MuiDataGrid-row.disabled-row': {
                        backgroundColor: 'inherit !important',
                        color: 'grey !important',
                    },
                    '& .MuiDataGrid-row.disabled-row .MuiDataGrid-cell': {
                        backgroundColor: 'inherit !important',
                        color: 'grey !important',
                        fontSize: 13,
                        border: 'none',
                    },
                    '& .MuiDataGrid-row.disabled-row:hover': {
                        backgroundColor: 'inherit !important',
                    },
                    // Add flag row style if duplicate-row
                    '& .MuiDataGrid-row.duplicate-row': {
                        backgroundColor: 'rgba(200, 0, 0, 0.1) !important',
                        color: 'grey !important',
                    },
                    '& .MuiDataGrid-row.duplicate-row .MuiDataGrid-cell': {
                        backgroundColor: 'rgba(200, 0, 0, 0.1) !important',
                        color: 'grey !important',
                        fontSize: 13,
                        border: 'none',
                    },
                    '& .MuiDataGrid-row.duplicate-row:hover': {
                        backgroundColor: 'rgba(200, 0, 0, 0.1) !important',
                    },
                }}
                getRowClassName={(params) =>
                    (edlSummary?.missing_plates ?? []).some(plate => plate.id === params.id) ? 'disabled-row'
                    : duplicatePlateIds.includes(params.id) ? 'duplicate-row'
                    : ''
                }
                initialState={{
                    pinnedColumns: { left: [GRID_CHECKBOX_SELECTION_COL_DEF.field] },
                }}
                isRowSelectable={(params) => !duplicatePlateIds.includes(params.id) && !(edlSummary?.missing_plates ?? []).some(plate => plate.id === params.id)}
                rows={rows}
                columns={
                    (pullType?.value ?? '').startsWith('Drama')
                    ?
                    [...clipnameColumn, ...dramaColumn, ...cutColumns]
                    :
                    [...clipnameColumn, ...vfxColumn, ...cutColumns, ...bufferColumns]
                }
                pageSize={4}
                disableRowSelectionOnClick
                checkboxSelection
                rowSelectionModel={selectionModel}
                onRowSelectionModelChange={(newModel) => {
                    setSelectionModel(newModel);
                }}
                rowHeight={80}
            />
    );
};

export default UploadIllusionModifyDatagrid;